import React from 'react';
import TreeItemField from 'routes/Explore/components/Sentence/components/TreeItemField';
import { TreeValue } from 'routes/Explore/components/Sentence/contexts/TreeValueContext';
import { TreeDataWithoutIntermediateFields } from 'routes/Explore/components/Sentence/helpers/treeData';

type Props = {
    category: string;
    domain: string;
    onClick: (field: TreeValue) => void;
    testid: string;
    table: string;
    treeData: TreeDataWithoutIntermediateFields;
};

export default function Fields({
    category,
    domain,
    onClick,
    table,
    testid,
    treeData,
}: Props): React.ReactElement {
    const fields = treeData[domain][category][table].map((field) => (
        <TreeItemField
            key={field.field}
            field={field}
            domain={domain}
            onClick={onClick}
            testid={testid}
        />
    ));
    return <>{fields}</>;
}
